var coll = document.getElementsByClassName("wo-collapsible");
var i;

window.addEventListener("load", function(event)
    {
        var coll = document.getElementsByClassName("wo-collapsible");
        var i;
        for (i = 0; i < coll.length; i++) {
            coll[i].classList.toggle("active");
            var content = coll[i].nextElementSibling;
            content.style.maxHeight = content.scrollHeight + "px";
        }
    }
);

var coll = document.getElementsByClassName("wo-collapsible");
var i;
for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
};





var coll=document.getElementsByClassName("wo-collapsible2"),i;
for(i=0;i<coll.length;i++)coll[i].addEventListener("click",function(){
    this.classList.toggle("active");
    var e=this.nextElementSibling;e.style.maxHeight?e.style.maxHeight=null:e.style.maxHeight="100%"}
    );




var lstbtn = document.getElementsByClassName("stamped-rewards-widget-button"),i;
for (i = 0; i < lstbtn.length; i++) {
  lstbtn[i].addEventListener("load", function(event) {
    console.log(lstbtn[i]);
    if(lstbtn[i].innerHTML === "Signup"){
        lstbtn[i].innerHTML = "Inscription";
    	};
    }
  )};